// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__lUvYF","filesListContainer":"PosDisputesFiles_filesListContainer__3q8yd","filesButton":"PosDisputesFiles_filesButton__1jPDf"};